import { useState, useEffect } from 'react';
import {getAllCompanies, getCompanyCategoryList} from "@/api/all-companies";


// 美元
function dollarFormatter(value: any, precision:number) {
    return ['', 'NaN', 'null', 'undefined'].includes(value)? '-' : '$' + Number(value).toFixed(precision);
}
function shortDateFormatter(date: any) {
    if (['', 'NaN', 'null', 'undefined'].includes(date)) {
        return '-'
    } else {
        // 将日期字符串转换为 Date 对象
        date = new Date(date)
        // 定义月份的缩写
        const monthAbbreviations = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ]
        // 获取月份（0-11）和年份
        const month = monthAbbreviations[date.getMonth()] // 获取月份缩写
        const year = date.getFullYear() // 获取年份
        // 返回格式化后的字符串
        return `${month}. ${year}`
    }
}

function millionFormatter(value:any, precision:number) {
    const emptyArr = ['', 'NaN', 'null', 'undefined'];
    if (emptyArr.includes(value)) {
        return '-'
    } else {
        if (value >= 1e9) {
            return `$${(value / 1e9).toFixed(precision)}B` // 转换为十亿
        } else if (value >= 1e4) {
            return `$${(value / 1e6).toFixed(precision)}M` // 转换为百万
        } else {
            return `$${value}`; // 小于百万，直接显示
        }
    }
}
export default function AllCompanies () {
    const [isMarketActive, setIsMarketActive] = useState<boolean>(true);
    // const [tableLoading, setTableLoading] = useState<boolean>(false);
    const [tableColumns] = useState<Array<{ title: string; dataIndex: string; key: string; align: string; width?: string }>>([
        { title: 'Company', dataIndex: 'name', key: 'name', align: 'left' },
        { title: 'Augment Price', dataIndex: 'latestAugmentPrice', key: 'latestAugmentPrice', align: 'left' },
        { title: 'Last Round Price', dataIndex: 'lastRoundPreferredSharePrice', key: 'lastRoundPreferredSharePrice', align: 'left'},
        { title: 'Last Round Valuation', dataIndex: 'valuation', key: 'valuation', align: 'left',width: '20rem'  },
        { title: 'Category', dataIndex: 'category', key: 'category', align: 'left', width: '20rem' },
        { title: 'Buy / Sell', dataIndex: 'buySell', key: 'buySell', align: 'left', width: '20rem' }
    ]);
    const [tableData, setTableData] = useState<any[]>([]);
    const [categoryList, setCategoryList] = useState<string[]>(['All', 'Aerospace', 'Aerospace and Defense', 'Agtech']);
    const [selectedCategoryList, setSelectedCategoryList] = useState<string[]>([]);
    // const [searchValue, setSearchValue] = useState<string>('');
    const [total, setTotal] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [keyword] = useState<string>('');
    const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

    useEffect(() => {
        getAllCompanyList();
        getCompanyCategoryList().then((res: string[]) => {
            setCategoryList(['All', ...res]);
        });

    }, [isMarketActive, currentPage, selectedCategoryList]);

    const getAllCompanyList = (): void => {
        // setTableLoading(true);
        const method = getAllCompanies;
        const filterItems: any[] = isMarketActive ? [{ field: 'isMarketActive', symbol: 'EQ', value: true }] : [];
        if (selectedCategoryList.length > 0) {
            filterItems.push({ field: 'category', symbol: 'IN', value: selectedCategoryList });
        }
        method(keyword, currentPage, pageSize, '', '', filterItems).then((res: any) => {
            setTableData(res?.content);
            // setTableLoading(false);
            setTotal(res.totalElements || 0);
        }).catch((err) => {
            // setTableLoading(false);
            setTotal(0);
            console.log(err);
        });
    };

    const pageChange = (page: number, size: number): void => {
        setCurrentPage(page);
        setPageSize(size);
    };

    const categorySelectChange = (e:any, val: string): void => {
        e.preventDefault();
        e.stopPropagation();
        if (val === 'All') return; // 已移动到单独处理
        setSelectedCategoryList(prev =>
            prev.includes(val)
                ? prev.filter(item => item !== val)
                : [...prev, val]
        );
    };
    const isMarketActiveChangeHandler = (): void => {
        setIsMarketActive(prev => !prev)
        setCurrentPage(1);
    };

    // 添加点击外部关闭功能
    useEffect(() => {
        const handleClickOutside = (e: any) => {
            if (!e.target.closest('.dropdown')) {
                setIsDropdownOpen(false);
            }else{
                setIsDropdownOpen(true);
                // document.addEventListener('click', handleClickOutside);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <div className="container bg-black text-white mx-auto px-4 mb-16 pt-0 sm:pt-0 md:pt-5">
            <div className="list border border-white mx-auto mt-0 my-8 p-4 width-[80%] max-w-[1200px] rounded-lg text-sm md:text-base lg:text-lg">
                <div className="btn-box flex justify-end mb-4">
                    <div className="btn-area flex gap-4">
                        <div className="switch-all flex items-center">
                            <span className="all font-medium mr-2 text-xs sm:text-sm md:text-base lg:text-lg">All</span>
                            <input type="checkbox" checked={isMarketActive} onChange={isMarketActiveChangeHandler} className="toggle text-blue-500 border-white" />
                            <span className="ml-2 text-xs sm:text-sm md:text-base lg:text-lg">Open Markets</span>
                        </div>
                        <div className={`dropdown dropdown-end text-sm md:text-base lg:text-lg ${isDropdownOpen? 'dropdown-open' : 'dropdown-hidden'}`}>
                            <button
                                className="btn px-1 sm:px-1 md:px-2 lg:px-2 py-0 sm:py-0 md:py-2 lg:py-2 text-xs sm:text-xs md:text-base"
                                onClick={()=>setIsDropdownOpen(!isDropdownOpen)}
                            >Category: {selectedCategoryList.length ? (selectedCategoryList.length === 1 ? selectedCategoryList[0] : `${selectedCategoryList.length} Selected`) : 'All'}</button>
                            <ul className="dropdown-content h-80 text-black menu p-4 shadow bg-base-100 rounded-box max-w-[400px]">
                                <div className="overflow-y-auto overflow-x-hidden">
                                    {categoryList.map((item, index) => (
                                        <li className="hover:bg-base-100 cursor-pointer" key={index} onClick={() => categorySelectChange(event,item)}>
                                            {index!==0?(
                                                <label className="label cursor-pointer">
                                                    <input type="checkbox" className="checkbox" checked={selectedCategoryList.includes(item)}
                                                           onChange={() => {}} // 必须有空事件处理器
                                                    />
                                                    <a className="whitespace-nowrap">{item}</a>
                                                </label>
                                            ): (
                                                <span>{item}</span>
                                            )}
                                        </li>
                                    ))}
                                </div>

                            </ul>
                        </div>
                    </div>
                </div>
                <div className="power-table overflow-auto rounded-t-md border border-gray-800 sm:rounded-t-lg md:rounded-t-xl">
                    <table className="min-w-full border-collapse border border-gray-800 rounded-tl-md sm:rounded-tl-lg md:rounded-tl-xl">
                        <thead>
                        <tr className="text-xs sm:text-sm md:text-base lg:text-lg pt-3 pb-3 overflow-hidden text-ellipsis whitespace-nowrap font-medium text-white">
                            {tableColumns.map((col, index) => (
                                <th key={index} className="px-2 sm:px-4 md:px-6 py-2 sm:py-4 bg-[#444648] text-center border border-gray-800 border-1">{col.title}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {tableData.map((record, index) => (
                            <tr key={index} className="hover:bg-[#333434] text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] pt-3 pb-3 border border-gray-800 border-1">
                                <td className="px-2 sm:py-2px-2 sm:px-4 md:px-6 py-1 sm:py-2 2 border border-gray-800 border-1">
                                    <div className="flex items-center">
                                        <div className="star-watched">
                                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0"
                                                 viewBox="0 0 1024 1024" className="sc-87d4087c-7 cocisv star-watched"
                                                 height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path>
                                            </svg>
                                        </div>
                                        <div className="avatar ml-2 sm:ml-2 md:ml-3">
                                            <div className="w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 rounded-full">
                                                <img  className="rounded-full object-cover w-full h-full" src={record.logoLink} alt={record.name}/>
                                            </div>
                                        </div>
                                        <div className="ml-2 sm:ml-2 md:ml-3 font-medium text-white text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px]">{record.name}</div>
                                    </div>
                                </td>
                                <td className="px-4 py-2 border border-gray-800 border-1">{dollarFormatter(record.latestAugmentPrice,2)}</td>
                                <td className="px-2 sm:py-2px-2 sm:px-4 md:px-6 py-1 sm:py-2  border border-gray-800 border-1">
                                    {dollarFormatter(record.lastRoundPreferredSharePrice, 2)}
                                </td>
                                <td className="px-2 sm:py-2px-2 sm:px-4 md:px-6 py-1 sm:py-2  border border-gray-800 border-1">
                                    <div>
                                        <div>{millionFormatter(record.valuation,2)}</div>
                                        <div className="overflow-hidden text-gray-400 text-ellipsis whitespace-nowrap">{shortDateFormatter(record.lastFundingDate)}</div>
                                    </div>
                                </td>
                                <td className="px-2 sm:py-2px-2 sm:px-4 md:px-6 py-1 sm:py-2  border border-gray-800 border-1">
                                    {/*<div className="tooltip" data-tip={record.category}>*/}
                                        <span className="badge text-white bg-gray-700 overflow-hidden text-ellipsis whitespace-nowrap border-gray-800 text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] p-2 sm:p-2 md:p-4 rounded-md">{record.category}</span>
                                    {/*</div>*/}
                                </td>
                                <td className="px-2 sm:py-2px-2 sm:px-4 md:px-6 py-1 sm:py-2  border border-gray-800 border-1">
                                    <div className="flex items-start">
                                        <div>
                                            <a href={record.bidLink}>{ dollarFormatter(record.highestBid,2) }</a>
                                            <div className="text-gray-400 overflow-hidden text-ellipsis whitespace-nowrap">{ record.numActiveBids || 0 } orders</div>
                                        </div>
                                        <div className="mr-2">/</div>
                                        <div>
                                            <a href="/c/xai?poststab=asks" >{ dollarFormatter(record.lowestAsk,2) }</a>
                                            <div className="text-gray-400 overflow-hidden text-ellipsis whitespace-nowrap">{ record.numActiveAsks || 0 } orders</div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="flex justify-end mt-4">
                    <div className="pagination">
                        <button className="btn btn-primary bg-blue-500 border-none text-xs sm:text-sm md:text-base py-0" disabled={currentPage === 1} onClick={() => pageChange(currentPage - 1, pageSize)}>Previous</button>
                        <span className="mx-2 text-xs sm:text-sm md:text-base">Page {currentPage} of {Math.ceil(total / pageSize)}</span>
                        <button className="btn btn-primary bg-blue-500 border-none text-xs sm:text-sm md:text-base py-0" disabled={currentPage === Math.ceil(total / pageSize)} onClick={() => pageChange(currentPage + 1, pageSize)}>Next</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

